export const LastUpdated = '06 Février 2026';
